import { render, staticRenderFns } from "./affiliation.vue?vue&type=template&id=6009db4c&scoped=true&"
import script from "./affiliation.vue?vue&type=script&lang=js&"
export * from "./affiliation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6009db4c",
  null
  
)

export default component.exports